// 本文中のリンクは読んでいるページを離れないよう新しいタブで開く
export function DocLink({ href, children }: { href: string; children: React.ReactNode }) {
	return (
		<a href={href} target="_blank" rel="noreferrer" className="text-accent">
			{children}
		</a>
	);
}
